import DataLayer from '../../utilities/dataLayer';
export const name = 'isLoggedIn';
/**
 * Determines if current user is logged in (uses information from dataLayer)
 */
const isLoggedIn = async () => {
    const visitor = await DataLayer.get('visitor');
    return visitor.status === 'Logged in';
};
isLoggedIn.defaultMessage = 'You must be logged in to use this.';
export { isLoggedIn };
